import React from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";


const BASE_URL = "https://www.dc-ac.com";

const SEOHead = ({ title, description, location, lang = "en" }) => {
  // Ensure path starts with / if not empty, and doesn't end with / unless it is root
  // We need to parse the logical path from the current location.pathname
  // e.g. /ja/company -> /company
  // e.g. /company -> /company
  let rawPath = (location && location.pathname) || "";
  
  const langs = ["/en", "/ja", "/zh-TW", "/zh-tw", "/zh"];
  let cleanPath = rawPath;
  for (const l of langs) {
      if (cleanPath.startsWith(l)) {
          cleanPath = cleanPath.substring(l.length);
          break;
      }
  }
  if (!cleanPath.startsWith("/")) cleanPath = "/" + cleanPath;
  // Handle root case carefully: if it becomes just "", make it "/"
  if (cleanPath === "") cleanPath = "/";

  
  // Construct language specific URLs
  const getUrl = (l) => {
    // English (default) uses /en/ prefix for SEO canonicals now?
    // User Requirement: "Introduce language-prefixed URLs (e.g., /en/, /ja/, /zh-TW/) for improved SEO."
    // "Existing URLs remain functional... canonical tags pointing to the prefixed English version."
    // So YES, English canonical is /en/path.
    
    const prefix = `/${l}`;
    // If path is root '/', result is '/en/' or '/ja/'
    if (cleanPath === "/" || cleanPath === "") {
        return `${BASE_URL}${prefix}/`;
    }
    // Avoid double slash if cleanPath starts with /
    return `${BASE_URL}${prefix}${cleanPath}`.replace(`${BASE_URL}//`, `${BASE_URL}/`);
  };

  const currentCanonical = getUrl(lang);

  return (
    <Helmet>
      <html lang={lang} />
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      
      {/* Canonical */}
      <link rel="canonical" href={currentCanonical} />
      <meta property="og:url" content={currentCanonical} />

      {/* hreflang tags */}
      <link rel="alternate" hreflang="en" href={getUrl("en")} />
      <link rel="alternate" hreflang="ja" href={getUrl("ja")} />
      <link rel="alternate" hreflang="zh-TW" href={getUrl("zh-TW")} />
      <link rel="alternate" hreflang="x-default" href={getUrl("en")} />
    </Helmet>
  );
};

SEOHead.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  location: PropTypes.object.isRequired, // React Router location object
  lang: PropTypes.string,
};

export default SEOHead;
